import { render } from "./OfferVMC.vue?vue&type=template&id=7ef49978"
import script from "./OfferVMC.vue?vue&type=script&lang=js"
export * from "./OfferVMC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__